import { Action } from '@ngrx/store';

import { LibraryAvailability } from './library-availability';

export enum LibraryAvailabilityActionTypes {
  LIBRARY_AVAILABILITY_REQUEST_UNLESS_CACHED = '[Library availability] Library availability request unless cached',
  LIBRARY_AVAILABILITY_REQUESTED = '[Library availability] Library availability requested',
  LIBRARY_AVAILABILITY_LOADED = '[Library availability] Library availability loaded',
  LIBRARY_AVAILABILITY_LOADING_FAILED = '[Library availability] Library availability loading failed',
}

export interface FetchLibraryAvailabilityUnlessCachedPayload {
  resourceId: string;
}

export class FetchLibraryAvailabilityUnlessCachedAction implements Action {
  readonly type =
    LibraryAvailabilityActionTypes.LIBRARY_AVAILABILITY_REQUEST_UNLESS_CACHED;

  constructor(public payload: FetchLibraryAvailabilityUnlessCachedPayload) {}
}

export interface FetchLibraryAvailabilityPayload {
  resourceId: string;
}

export class FetchLibraryAvailabilityAction implements Action {
  readonly type = LibraryAvailabilityActionTypes.LIBRARY_AVAILABILITY_REQUESTED;

  constructor(public payload: FetchLibraryAvailabilityPayload) {}
}

export interface LibraryAvailabilityLoadedPayload
  extends FetchLibraryAvailabilityPayload {
  libraryAvailability: LibraryAvailability;
}

export class LibraryAvailabilityLoadedAction implements Action {
  readonly type = LibraryAvailabilityActionTypes.LIBRARY_AVAILABILITY_LOADED;

  constructor(public payload: LibraryAvailabilityLoadedPayload) {}
}

export interface LibraryAvailabilityLoadingFailedPayload
  extends FetchLibraryAvailabilityPayload {
  error: any;
}

export class LibraryAvailabilityLoadingFailedAction implements Action {
  readonly type =
    LibraryAvailabilityActionTypes.LIBRARY_AVAILABILITY_LOADING_FAILED;

  constructor(public payload: LibraryAvailabilityLoadingFailedPayload) {}
}

export type LibraryAvailabilityActions =
  | FetchLibraryAvailabilityAction
  | LibraryAvailabilityLoadedAction
  | LibraryAvailabilityLoadingFailedAction;
